import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8.968 3.35c-.263.004-.654.193-.743.86a69.91 69.91 0 0 1-.29 1.87h1.397a.65.65 0 0 1 0 1.3h-1.61a161.037 161.037 0 0 0-.665 4.359c-.096.707-.349 1.27-.74 1.66a1.848 1.848 0 0 1-1.383.55c-.94-.035-1.834-.797-1.834-1.903a.65.65 0 1 1 1.3 0c0 .341.273.592.582.604a.549.549 0 0 0 .418-.173c.139-.138.3-.41.369-.913.199-1.466.429-2.917.636-4.184H4.917a.65.65 0 1 1 0-1.3h1.701c.14-.848.253-1.55.318-2.04.167-1.254 1.052-1.974 2.01-1.99.95-.015 1.848.683 1.874 1.876a.65.65 0 0 1-1.3.029c-.01-.44-.279-.61-.552-.605ZM8.87 8.878a.65.65 0 0 1 .92-.004l1 .993 1.002-.993a.65.65 0 0 1 .916.923l-.994.986.994.986a.65.65 0 1 1-.916.923l-1.001-.994-1.002.994a.65.65 0 1 1-.915-.923l.994-.986-.994-.986a.65.65 0 0 1-.004-.92Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
